
import { FuncionarioISecaoItem } from '../FuncionarioItem';
import { IDiretoriaSecaoComponentProps } from '@/@types/Contato/Diretoria';


const DiretoriaSecaoComponent = ({ diretorData, diretoriaAssociadaData, atuSecaoData, secretariaDirecaoSecaoData, diretorSecaoData, diretoriaAssociadaSecaoData }: IDiretoriaSecaoComponentProps) => {

    return (
        <div>
            <div>
                {/* diretoria */}
                <h2 className='font-normal leading-[40px] text-[1.5rem] uppercase'>Diretor</h2>

                <FuncionarioISecaoItem
                    nome={diretorSecaoData.secoes_user_displayName}
                    email={diretorSecaoData.secoes_user_mail}
                    email2={diretorSecaoData.secoes_email}
                    telefone={diretorData?.telefone}
                    lattes={diretorData?.lattes}
                />

            </div>

            <div>
                {/* diretoria associada */}
                <h2 className='font-normal leading-[40px] text-[1.5rem] uppercase'>{diretoriaAssociadaSecaoData.secoes_descricao}</h2>

                    <FuncionarioISecaoItem
                        nome={diretoriaAssociadaSecaoData.secoes_user_displayName}
                        email={diretoriaAssociadaSecaoData.secoes_user_mail}
                        telefone={diretoriaAssociadaData?.telefone}
                        lattes={diretoriaAssociadaData?.lattes}
                    />
            </div>

            <div>
                {/* atu */}
                <h2 className='font-normal leading-[40px] text-[1.5rem] uppercase'>{atuSecaoData.secoes_descricao}</h2>

                <FuncionarioISecaoItem
                    nome={atuSecaoData.secoes_user_displayName}
                    email={atuSecaoData.secoes_email}
                    telefone={atuSecaoData.secoes_telefones}
                />
            </div>

            <div>
                {/* secretaria direção */}
                <h2 className='font-normal leading-[40px] text-[1.5rem] uppercase'>{secretariaDirecaoSecaoData.secoes_descricao}</h2>

                <FuncionarioISecaoItem
                    nome={secretariaDirecaoSecaoData.secoes_user_displayName}
                    email={secretariaDirecaoSecaoData.secoes_email}
                    telefone={secretariaDirecaoSecaoData.secoes_telefones}
                />
            </div>

        </div>
    )
}

export { DiretoriaSecaoComponent };